function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  border: 1px dashed black;\n  padding: 10px;\n  background: #00000008;\n\n  del {\n    color: white;\n    background-color: red;\n  }\n  ins {\n    color: white;\n    background-color: green;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import diff from "node-htmldiff";
import { mutateDocumentHtml, sanitizeForDiff } from "../../../../modules/proposals/utils";
import { useProvidedBuilder } from "../DocumentEditorWrapper";
export var ChangeLogView = function(param) {
    var show = param.show;
    var builder = useProvidedBuilder();
    var ref = _slicedToArray(useState(""), 2), prevHtml = ref[0], setPrevHtml = ref[1];
    useEffect(function() {
        if (prevHtml) return;
        mutateDocumentHtml({
            template: builder.template,
            context: builder.context,
            config: builder.config
        }).then(function(result) {
            setPrevHtml(result);
        });
    }, [
        builder.template,
        builder.context,
        builder.config
    ]);
    var __html = useMemo(function() {
        return diff(sanitizeForDiff(prevHtml), sanitizeForDiff(builder.html));
    }, [
        prevHtml,
        builder.html
    ]);
    if (!show) return null;
    return /*#__PURE__*/ React.createElement(StyledChangeLogView, {
        dangerouslySetInnerHTML: {
            __html: __html
        }
    });
};
var StyledChangeLogView = styled.div(_templateObject());
